/**
 * Created by rvvslv on 13.01.21.
 */

const MenuBarWithTimeoutView = MenuBarItemView.extend({
    ctor: function (item) {
        this._super(item);

        this.item.onChangeTimer = this.createListener(this.onChangeTimer.bind(this));
        this.item.onRefreshTimer = this.createListener(this.onRefreshTimer.bind(this));
    },

    onChangeTimer: function () {
        if (this.timer) {
            const timerTTF = this.timer instanceof cleverapps.UI.LabelTTF;
            if (timerTTF !== this.item.timerTTF) {
                this.removeTimer();
            }
        }

        if (this.item.timer) {
            this.createTimer();
        } else {
            this.removeTimer();
        }
    },

    reset: function (silent) {
        this._super(silent);

        this.onChangeTimer(true);
    },

    createTimer: function () {
        if (this.timer || connector.platform.oneOf(connector.DIGITAL, connector.DIGITALWEB)) {
            return;
        }

        cleverapps.UI.updateScale9Sprite(this.bg, bundles.menubar.frames.menubar_bg_timer_png, cleverapps.UI.Scale9Rect.TwoPixelXY);

        this.bg.setContentSize(this.styles.bg.width, this.styles.bg.timerHeight);
        this.bg.setAlignment(this.styles.bg.width / 2 + this.iconRealWidth / 2, { align: "top" });

        if (this.item.timerTTF) {
            this.timer = cleverapps.UI.generateOnlyText("", cleverapps.styles.FONTS.MENUBAR_TIMER_TEXT);
        } else {
            this.timer = cleverapps.UI.generateImageText("", cleverapps.styles.FONTS.MENUBAR_TIMER_TEXT, { fixedNumberWidth: true });
        }
        this.timer.baseScale = 1;
        this.bg.addChild(this.timer);

        this.onRefreshTimer();
    },

    removeTimer: function () {
        if (!this.timer) {
            return;
        }

        cleverapps.UI.updateScale9Sprite(this.bg, bundles.menubar.frames.menubar_bg_png, cleverapps.UI.Scale9Rect.TwoPixelXY);

        this.bg.setContentSize(this.styles.bg.width, this.styles.bg.height);
        this.bg.setAlignment(this.styles.bg.width / 2 + this.iconRealWidth / 2, this.height / 2);

        this.timer.removeFromParent();
        this.timer = undefined;
    },

    onRefreshTimer: function () {
        if (!this.timer || this.item.getTimerString() === this.timer.getString()) {
            return;
        }

        this.timer.setString(this.item.getTimerString());
        this.timer.setFont(cleverapps.styles.FONTS.MENUBAR_TIMER_TEXT);
        this.timer.setScale(this.timer.baseScale);

        this.timer.fitTo(this.styles.timer.width, this.styles.timer.height);
        this.timer.setAlignment(this.styles.timer);
    }
});

cleverapps.overrideColors(cleverapps.styles.COLORS, {
    MENUBAR_TIMER_COLOR: new cc.Color(131, 243, 255, 255)
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    MENUBAR_TIMER_TEXT: {
        name: "default",
        size: 32,
        color: cleverapps.styles.COLORS.MENUBAR_TIMER_COLOR,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    }
});

cleverapps.overrideStyles(cleverapps.styles.MenuBarItem, {
    bg: {
        timerHeight: 119
    },

    timer: {
        x: { align: "center", dx: 20 },
        y: { align: "center", dy: -30 },
        width: 125,
        height: 60
    }
});
